<template>
    <VuePhoneNumberInput
        v-model="localPhone"
        :disabled="disabled"
        v-bind="$attrs"
        v-on="$listeners"
        :translations="translations"
        class="phone-number-input"
        :border-radius="10"
        size="sm"
        :default-country-code="defaultCountryCode"
    />
</template>

<script>
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';

    export default {
        name: 'totem-vue-form-number-input',
        components: {
            VuePhoneNumberInput
        },
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            defaultCountryCode () {
                return this.$totemLang.toUpperCase()
            }
        },
        data () {
            return {
                localPhone: '',
                translations: {
                    countrySelectorLabel: this.$t("VuePhoneNumberInput.country_code"),
                    phoneNumberLabel: this.$t("VuePhoneNumberInput.phone_number"),
                    example: this.$t("VuePhoneNumberInput.example")
                }
            }
        },
        watch: {
            localPhone () {
                this.$emit('input', this.localPhone)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .phone-number-input {
        max-width: 264px;
    }
</style>
